import { render, staticRenderFns } from "./MchPayIfConfigList.vue?vue&type=template&id=ed21a4ae&scoped=true"
import script from "./MchPayIfConfigList.vue?vue&type=script&lang=js"
export * from "./MchPayIfConfigList.vue?vue&type=script&lang=js"
import style0 from "./MchPayIfConfigList.vue?vue&type=style&index=0&id=ed21a4ae&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed21a4ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed21a4ae')) {
      api.createRecord('ed21a4ae', component.options)
    } else {
      api.reload('ed21a4ae', component.options)
    }
    module.hot.accept("./MchPayIfConfigList.vue?vue&type=template&id=ed21a4ae&scoped=true", function () {
      api.rerender('ed21a4ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mchApp/MchPayIfConfigList.vue"
export default component.exports